/**
 * Represents an instance of the staking flow. Staking flow requires a few steps
 * which should be done to stake BTC.
 */
export default class StakeInitialization {
    /**
     * Component representing an instance of the tBTC deposit process.
     */
    #tbtcDeposit;
    constructor(tbtcDeposit) {
        this.#tbtcDeposit = tbtcDeposit;
    }
    /**
     * @dev It should be used as a first step of the staking flow and user should
     *      send BTC to returned Bitcoin address.
     * @returns Bitcoin address corresponding to this deposit.
     */
    async getBitcoinAddress() {
        return this.#tbtcDeposit.getBitcoinAddress();
    }
    /**
     * @returns Receipt corresponding to the tbtc deposit.
     */
    getDepositReceipt() {
        return this.#tbtcDeposit.getReceipt();
    }
    /**
     * Stakes BTC based on the Bitcoin funding transaction via BitcoinDepositor
     * contract. By default, it detects and uses the outpoint of the recent
     * Bitcoin funding transaction and throws if such a transaction does not
     * exist.
     * @param options Optional options parameters to initialize stake.
     *                @see StakeOptions for more details.
     * @returns Transaction hash of the stake initiation transaction.
     */
    async stake(options = { retries: 5, backoffStepMs: 5_000 }) {
        await this.#tbtcDeposit.waitForFunding(options);
        return this.#tbtcDeposit.createDeposit();
    }
}
//# sourceMappingURL=staking.js.map